import { Wrapper } from './style';
import { useNavigate, useParams } from 'react-router-dom';
import { WarningIcon, PlusIcon, CheckedIcon } from './icons';
import { useState } from 'react';
import { useGetWorkflowById } from '../../../../services/workflow.services';
import { ProjectContainer } from '../../style';
import { getStatus, statusKeys } from '../data';
import toast from 'react-hot-toast';
import { useUploadFundFiles } from '../../../../services/funds.service';
import { LoadingCircle } from '../../Funds/icons';

import Button from '../../../../components/Button';
import Breadcrumb from '../../../../components/Breadcrumb';
import Table from '../../../../components/Table';
import { REPORT_NAMINGS } from '../../../../consts/reportTypes';
import { DropZone } from '../../../../components/DropZone';
import { Tooltip } from '@mantine/core';

export default function AddFile() {
  const navigate = useNavigate();
  const { periodId, id } = useParams();

  const [isMutating, setIsMutating] = useState(false);
  const [currentFunds, setCurrentFunds] = useState([]);
  const [isOpenAddFundModal, setIsOpenAddFundModal] = useState(false);

  const uploadFundFiles = useUploadFundFiles();

  const {
    data: quarters,
    isLoading,
    refetch
  } = useGetWorkflowById({
    id,
    queryParams: {
      enabled: !!id
    }
  });

  const toggleAddFundModal = () => {
    setIsOpenAddFundModal(prev => !prev);
  };

  const status = getStatus(quarters?.periods?.find(el => el.id === periodId) || {});
  const isAllowedToEdit = status === statusKeys.FILES;

  const columns = [
    {
      title: <div>Previous Period</div>,
      key: 'previous'
    },
    {
      title: <div>Current Period</div>,
      key: 'current'
    }
  ];

  const onSave = async () => {};

  const handleFileDrop = files => {
    const totalFiles = files.length;

    if (!totalFiles) return;

    const formData = new FormData();
    files.forEach(file => formData.append('files', file));

    let uploadedCount = 0;

    const toastId = toast.loading(`Uploading ${uploadedCount}/${totalFiles}`, {
      style: {
        width: 200
      },
      icon: <LoadingCircle />,
      position: 'bottom-center'
    });

    setIsMutating(true);

    uploadFundFiles.mutate(
      {
        data: formData,
        periodId,
        onUploadProgress: data => {
          let cumulativeSize = 0;

          files.forEach((file, idx) => {
            cumulativeSize += file.size;
            if (data.loaded >= cumulativeSize) {
              uploadedCount = idx + 1;
            }
          });

          toast.loading(`Uploading ${Math.min(uploadedCount, totalFiles)}/${totalFiles}`, {
            id: toastId
          });
        }
      },
      {
        onSuccess: () => {
          refetch();

          toast.dismiss(toastId);
          toast.success('All files uploaded successfully!', {
            position: 'bottom-center'
          });
        },
        onError: () => {
          toast.dismiss(toastId);
          toast.error('Failed to upload files.', {
            position: 'bottom-center'
          });
        },
        onSettled: () => {
          setIsMutating(false);
        }
      }
    );
  };

  return (
    <>
      <Wrapper width="100%">
        <ProjectContainer width="100%">
          <div className="header">
            <Breadcrumb
              withBackButton={true}
              isLoading={isLoading}
              prevLink={`/project/quaters/${id}`}
              links={[
                { name: `${REPORT_NAMINGS.PROJECT?.[quarters?.report_type]}s`, value: '/project' },
                { name: quarters?.name, value: `/project/quaters/${id}` },
                { name: `Add ${REPORT_NAMINGS.FUND?.[quarters?.report_type]}s` }
              ]}
            />

            {isAllowedToEdit && (
              <div className="actions">
                <Button
                  size="xs"
                  rightIcon={!isMutating && <CheckedIcon />}
                  disabled={isMutating}
                  onClick={onSave}
                >
                  {isMutating ? 'Saving...' : 'Save'}
                </Button>
              </div>
            )}
          </div>
          <div className="box" style={{ width: '100%' }}>
            <div className="header">
              <div className="warning-text">
                <WarningIcon />
                <p>Upload the files and reconcile them with the previous period</p>
              </div>
              {isAllowedToEdit && (
                <Tooltip label="Drag and drop files or click to browse" disabled={isMutating}>
                  <div>
                    <DropZone
                      dragLabel="Drop Here to upload files for all funds"
                      onDrop={handleFileDrop}
                      variant="compact"
                      disabled={isMutating}
                    >
                      <Button
                        onClick={toggleAddFundModal}
                        variant="transparent"
                        size="xs"
                        leftIcon={<PlusIcon />}
                        disabled={isMutating}
                      >
                        Upload Files for All {REPORT_NAMINGS.FUND?.[quarters?.report_type]}s
                      </Button>
                    </DropZone>
                  </div>
                </Tooltip>
              )}
            </div>

            <Table columns={columns} data={[]} hasIndex />
          </div>
        </ProjectContainer>
      </Wrapper>
    </>
  );
}
